/**
 * ThirdNav: Toggle for third nav.
 */


(function ($) {
    $(".cross-menu ").click(function () {
        if ($('.block-menu-mobile').hasClass("open-state")) {
            $('.block-menu-mobile').removeClass("open-state");
        }
    })
    $(".HeaderMobile-menu").click(function () {
        if (!$('.block-menu-mobile').hasClass("open-state")) {
            $('.block-menu-mobile').toggleClass("open-state");
        }
    })
})
(jQuery);



//////////






